/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable unused-imports/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { 
  DialogTitle, 
  DialogContent, 
  DialogActions,
  IconButton,
  Box,
  MenuItem
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@/components/typography/typography';
import Modal from '@/components/modal/modal';
import { deleteV1TemplatesId, getV1Templates, patchV1TemplatesIdSetDefault } from '@/api-client/api.system-feature/api';
import { getErrorMessage, getToken } from '@/utils/common';
import Button from '@/components/button/button';
// import ModalLoader from '@/components/loader/modal-loader';
import { useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import Select from '@/components/select/select';
import HtmlThumbnailPreview from './html-thumbnail-preview';
import HtmlThumbnailPreviewFull from './html-thumbnail-preview-full';
import ConfirmPopUp from '@/components/confirm-modal/confirm-modal';

const TemplateModal = ({ email, onClose, open, companies = [], templateRoutes, source = 'add' }) => {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [defaultTemplate, setDefaultTemplate] = useState('');
  const [loading, setLoding] = useState(true);
  const [selectedCompany, setSelectedCompany] = React.useState<number>(companies?.[0]?.id || 0);
  const [templateToDelete, setTemplateToDelete] = React.useState<Record<string, any> | null>(null);
  const [selectedTemplateForPreview, setSelectedTemplateForPreview] = useState(null);

  const navigate = useNavigate();

  const handleClose = () => {
    onClose();
  };

  const handleViewTemplate = (idToView: string) => {
        navigate(templateRoutes.EDIT_TEMPLATE(email._id, idToView || selectedTemplate), { 
            state: { company_id: selectedCompany, isViewOnly: true, fromPreview: true }
        });
    };

  const handleTemplateSelect = (id: any) => {
    if (source === 'view') {
      const template = templates.find((t: any) => t?._id === id);
      setSelectedTemplateForPreview(template);
      setSelectedTemplate(id);
      handleViewTemplate(id);
    } else {
      setSelectedTemplate(id);
    }
  }

  const getTemplatesViaSubject = async () => {
    setLoding(true)
    const res = await getV1Templates({ ...getToken(),  filters: `(company_id.eq=${selectedCompany}&subject_id.eq=${email._id})` })
    if(res?.data) {
      const dTemplate = res?.data?.find(t => t.is_default === true)
      setDefaultTemplate(dTemplate)
      setSelectedTemplate(dTemplate?._id)
      setTemplates(res?.data)
    }

    setLoding(false)
  }

  const handleDefaultTemplate = async () => {
    try {
      await patchV1TemplatesIdSetDefault({ ...getToken(), id: selectedTemplate })
      enqueueSnackbar('Template has been set as default');
      await getTemplatesViaSubject();
    } catch (error) {
      const m = getErrorMessage(error?.message);
      enqueueSnackbar(m, { variant: 'error' });
    }
  }

  const handleDeleteTemplate = async () => {
    try {
      if(templateToDelete) {
        await deleteV1TemplatesId({ ...getToken(), id: templateToDelete?._id })
        enqueueSnackbar('Template has been deleted');
        setTemplateToDelete(null)
        await getTemplatesViaSubject()
      }
    } catch (error) {
      const m = getErrorMessage(error?.message);
      enqueueSnackbar(m, { variant: 'error' });
    }
  }

  useEffect(() => {
    getTemplatesViaSubject()
    return () => { setLoding(true) }
  }, [selectedCompany])

  return (
    <div>
      <Modal 
        open={open} 
        onClose={handleClose} 
        maxWidth="lg" 
        fullWidth
        aria-labelledby="email-template-selection"
        sx={{
          '& .MuiDialog-paper': {
            height: '85vh',
            display: 'flex',
            flexDirection: 'column'
          }
        }}
      >

        {console.log(source, "soure in modal +++++++++++++++++++++++debug")}
        {/* {loading && <ModalLoader/>} */}
        <DialogTitle sx={{ marginBottom: '1rem', padding: '0.75rem 1rem 0.75rem 1.5rem', borderBottom: '1px solid #D3D3D4'}}>
          <Box display='flex' alignItems='center' gap={2}>
            {selectedTemplateForPreview && (
              <IconButton
                onClick={() => setSelectedTemplateForPreview(null)}
                size='small'
                sx={{ color: (theme) => theme.palette.grey[700] }}
              >
                <Typography>← Back</Typography>
              </IconButton>
            )}
            <Typography type='s1' weight='medium' color='theme.secondary.1000' sx={{ flex: 1, textAlign: 'center' }}> 
              {selectedTemplateForPreview ? 'Template Preview' : (source === 'view' ? 'Template Preview' : 'Select Template')}
            </Typography>
          </Box>
          <Box display='flex' alignItems={'center'} gap={1} position='absolute' right='1%' top='4px'>
            <Typography type='s3' weight='medium' color='theme.secondary.800'> Company</Typography>
            <Select
              displayEmpty
              value={selectedCompany}
              size='small'
              renderValue={(value) => value ? companies.find((option) => option.value === value)?.label : 'Select Company'}
              // fullWidth
              // sx={{
              //   bgcolor: 'white',
              //   borderRadius: 1,
              //   '& .MuiSelect-select': { py: 0.75 }
              // }}
              onChange={(e) => {
                if (e.target.value) {
                  setSelectedCompany(e.target.value as number);
                }
              }}>
              {companies.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <Typography type='s3' color='theme.secondary.1000'>{option.label}</Typography>
                </MenuItem>
              ))}
            </Select>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              size='small'
              sx={{
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon fontSize='small'/>
            </IconButton>
          </Box>
        </DialogTitle>
  
        {
          selectedTemplateForPreview ? (
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 3, width: '100%', p: 3, flex: 1, overflow: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none', '&::-webkit-scrollbar': { display: 'none' } }}>
              {/* Main Preview */}
              <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <HtmlThumbnailPreviewFull
                  template={selectedTemplateForPreview}
                  width={'100%'}
                  height={600}
                  scale={1}
                  showControls={true}
                  isFetching={loading}
                  normalView={true}
                />
              </Box>
            </DialogContent>
        ) : (
          <DialogContent sx={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column', scrollbarWidth: 'none', msOverflowStyle: 'none', '&::-webkit-scrollbar': { display: 'none' } }}>
          {/* <Grid container spacing={6}> */}
            {!templates.length && (
              // <Grid item xs={12} sx={{ minHeight: 350}}>
                <Box display='flex' alignItems='center' width='100%' height='100%' justifyContent='center'>
                  {!loading && <Typography type='s1' weight='medium' color='theme.secondary.1000' sx={{ textAlign: 'center' }}>No templates found</Typography>}
                </Box>
              // </Grid>
            )}
              <Box sx={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', 
                gap: 2, 
                p: 2,
                justifyItems: 'center',
                alignItems: 'center'
              }}>
                {templates.map((template, index) => (
                  <HtmlThumbnailPreview
                    key={template._id || index}
                    template={template}
                    width={300}
                    height={200}
                    showControls={source === 'add'}
                    selectedTemplateId={selectedTemplate}
                    onClick={(template: any) => {
                      handleTemplateSelect(template._id)
                    }}
                    normalView={source === 'add'}
                    isFetching={loading}
                    onDelete={(template: any) => setTemplateToDelete(template)}
                  />
                ))}
              </Box>
          </DialogContent>
        )}
        {source === 'add' && (
          <DialogActions sx={{ p: 2, justifyContent: 'center', borderTop: '1px solid #D3D3D4' }}>
            <Button
              onClick={() => navigate(templateRoutes.EDIT_TEMPLATE(email._id, selectedTemplate), { state: { company_id: selectedCompany } })}
              disabled={!selectedTemplate}
            >
              Continue
            </Button>
            <Button
              onClick={() => handleDefaultTemplate()}
              disabled={!selectedTemplate || defaultTemplate?._id === selectedTemplate}
            >
              Set to Default
            </Button>
          </DialogActions>
        )}
      </Modal>
      <ConfirmPopUp
        open={templateToDelete !== null}
        onClose={() => setTemplateToDelete(null)}
        title='Remove Template'
        description='Are you sure you want to delete ?'
        onConfirm={() => handleDeleteTemplate()}
        loading={loading}
      />
    </div>
  );
};

export { TemplateModal };
export default TemplateModal;